var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container",
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.displayText)
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }